<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><i>“What is the difference, in morality, between the totally anarchic criminality of the artist, which is endemic in all fine creative minds, and the artistry of the criminal?"</i></p>
<p class="alignment-block-content alignment-block-content-left"><b>— John le Carré</b></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?dd25ae20